// PDF React View
import UploadForm from "components/shared-components/UploadForm";
import { ISSUE_INVOICE_HHDV_FIELD } from "constants/IssueInvoiceConstant";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import readXlsxFile from "read-excel-file";
const UploadProductExcelModal = props => {
  const { isOpen, toggle, listVat, importHandle, OPTION_HHDV_TCHAT } = props;
  const { addToast } = useToasts();

  const [listProduct, setListProduct] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setListProduct([]);
    }
  }, [isOpen]);

  const handleFiles = (files, uploadType = "") => {
    if (files.length > 0) {
      let data = [];
      readXlsxFile(files[0]).then(rows => {
        rows.shift();
        for (const item of rows) {
          const product = {
            stt: item[0],
            mhhdvu: item[1] ? item[1] : "",
            thhdvu: item[2] ? item[2] : "",
            dvtinh: item[3] ? item[3] : "",
            sluong: item[4] ? item[4] : 0,
            dgia: item[5] ? item[5] : 0,
            thtien: item[6] ? item[6] : 0,
            tsuat: item[7],
          };
          product.thtien = product.sluong * product.dgia;
          let tsuat = {};
          switch (product.tsuat) {
            case "KCT":
            case "KKKNT":
              tsuat = {
                value: 0,
                label: product.tsuat,
              };
              break;
            default:
              switch (typeof product.tsuat) {
                // Thue suat number
                case "number":
                  const valueTsuat = Math.round(product.tsuat * 100);
                  const vat1 = listVat
                    .filter(
                      item => item.label !== "KCT" && item.label !== "KKKNT"
                    )
                    .find(item => Number(item.value) === Number(valueTsuat));
                  if (vat1) {
                    tsuat = vat1;
                  } else {
                    let value = valueTsuat;
                    tsuat = {
                      value: value,
                      label: "KHAC:" + String(value).padStart(2, "0") + ".00%",
                    };
                  }
                  break;
                // Thue suat string
                case "string":
                  const countPercent = (product.tsuat.match(/%/g) || []).length;
                  // Có 1 ký tự %
                  if (countPercent === 1) {
                    const vat = listVat
                      .filter(
                        item => item.label !== "KCT" && item.label !== "KKKNT"
                      )
                      .find(item => item.label === product.tsuat);
                    if (vat) {
                      tsuat = vat;
                    } else {
                      let value = product?.tsuat?.split("%")[0];
                      tsuat = {
                        value: value,
                        label:
                          "KHAC:" + String(value).padStart(2, "0") + ".00%",
                      };
                    }
                  } else {
                    tsuat = {
                      value: "",
                      label: "",
                    };
                  }
                  break;
                default:
                  break;
              }
              break;
          }
          data.push({
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TCHAT.field]:
              OPTION_HHDV_TCHAT[0],
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.STT.field]: product.stt,
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.MHHDVU.field]:
              product.mhhdvu,
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.THHDVU.field]:
              product.thhdvu,
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.DVTINH.field]:
              product.dvtinh,
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.SLUONG.field]: Number(
              product.sluong
            ),
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.DGIA.field]: Number(
              product.dgia
            ),
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TLCKHAU.field]: "",
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.STCKHAU.field]: "",
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.THTIEN.field]: Number(
              product.thtien
            ),
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TSUAT.field]: tsuat,
            [ISSUE_INVOICE_HHDV_FIELD.HHDV_OBJ.list.TTKHAC.field]: "",
          });
        }
        setListProduct(data);
      });
    }
  };

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Nhập file</Label>
        </ModalHeader>
        <ModalBody>
          <UploadForm
            multiple={false}
            handleFiles={files => handleFiles(files)}
            accept=".xlsx"
            removeFile={(a, index) => {
              setListProduct([]);
            }}
          ></UploadForm>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={listProduct.length === 0}
            onClick={() => {
              importHandle && importHandle(listProduct);
            }}
          >
            <i className="bx bx-save label-icon" />
            Lưu thông tin
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

UploadProductExcelModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  listVat: PropTypes.array,
  importHandle: PropTypes.any,
  OPTION_HHDV_TCHAT: PropTypes.any,
};

export default UploadProductExcelModal;
